import { cn } from 'utils/bem';

export const toast = cn('toast');
